import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

// [VinUni] Module 6 - Hợp đồng TLNC (RA)

export const getAllContract = () => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.getAllContract();
  dispatch({
    type: TYPE.RA_CONTRACT.GET_ALL_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_ALL_CONTRACT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_ALL_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy danh sách hợp đồng thất bại!" }));
  }
};

export const getContractByProfileId = (profileId) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.getContractByProfileId(profileId);
  dispatch({
    type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_PROFILE_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy hợp đồng theo cá nhân thất bại!" }));
  }
};

export const getContractById = (id) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.getContractById(id);
  dispatch({
    type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_BY_ID_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy chi tiết hợp đồng thất bại!" }));
  }
};

export const insertContract = (payload, cleanUp) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.insertContract();
  dispatch({
    type: TYPE.RA_CONTRACT.INSERT_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.INSERT_CONTRACT_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Thêm hợp đồng thành công!" }));
    dispatch(getAllContract());
    if (cleanUp) cleanUp();
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.INSERT_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Thêm hợp đồng thất bại!" }));
  }
};

export const updateContract = (id, payload, cleanUp) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.updateContract(id);
  dispatch({
    type: TYPE.RA_CONTRACT.UPDATE_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.UPDATE_CONTRACT_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Cập nhật hợp đồng thành công!" }));
    dispatch(getAllContract());
    if (cleanUp) cleanUp();
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.UPDATE_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Cập nhật hợp đồng thất bại!" }));
  }
};

export const deleteContract = (id) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.deleteContract(id);
  dispatch({
    type: TYPE.RA_CONTRACT.DELETE_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.DELETE_CONTRACT_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Xoá hợp đồng thành công!" }));
    dispatch(getAllContract());
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.DELETE_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Xoá hợp đồng thất bại!" }));
  }
};

export const setActiveContract = (id, active) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.setActiveContract(id, active);
  dispatch({
    type: TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Cập nhật trạng thái kích hoạt thành công!" }));
    dispatch(getAllContract());
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.SET_ACTIVE_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Cập nhật trạng thái kích hoạt thất bại!" }));
  }
};

export const setCompletedContract = (id, completed) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.setCompletedContract(id, completed);
  dispatch({
    type: TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Cập nhật trạng thái hoàn thành thành công!" }));
    dispatch(getAllContract());
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.SET_COMPLETED_CONTRACT_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Cập nhật trạng thái hoàn thành thất bại!" }));
  }
};

export const addAcceptance = (contractId, payload, cleanUp) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.addAcceptance(contractId);
  dispatch({
    type: TYPE.RA_CONTRACT.ADD_ACCEPTANCE_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.ADD_ACCEPTANCE_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Thêm nghiệm thu thành công!" }));
    dispatch(getContractById(contractId));
    dispatch(getAllContract());
    if (cleanUp) cleanUp();
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.ADD_ACCEPTANCE_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Thêm nghiệm thu thất bại!" }));
  }
};

export const deleteAcceptance = (acceptanceId, contractId) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.deleteAcceptance(acceptanceId);
  dispatch({
    type: TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_SUCCESS,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Xoá nghiệm thu thành công!" }));
    if (contractId) dispatch(getContractById(contractId));
    dispatch(getAllContract());
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.DELETE_ACCEPTANCE_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Xoá nghiệm thu thất bại!" }));
  }
};

export const getAvailablePapers = (profileId) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.getAvailablePapers(profileId);
  dispatch({
    type: TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_AVAILABLE_PAPERS_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy danh sách bài báo khả dụng thất bại!" }));
  }
};

export const getWarnings = (profileId) => async (dispatch) => {
  const api = API_URLS.RA_CONTRACT.getWarnings(profileId);
  dispatch({
    type: TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_LOADING,
    meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.RA_CONTRACT.GET_CONTRACT_WARNINGS_FAILURE,
      meta: { prefix: [PREFIX.RA_CONTRACT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy cảnh báo hợp đồng thất bại!" }));
  }
};
